/**
 * Группа уведомлений с заголовком даты
 */

import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsSection } from '@/components';
import type { NotificationDateGroup } from '../lib';

interface NotificationGroupProps {
  group: NotificationDateGroup;
  children: ReactNode;
}

export const NotificationGroup = memo(function NotificationGroup({ group, children }: NotificationGroupProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <SettingsSection
      title={t(`notifications:notification.dateGroups.${group}`)}
      cardClassName="px-4 py-4 gap-4 overflow-hidden"
      className="mb-4"
    >
      {children}
    </SettingsSection>
  );
});